import type { BoxProps } from '@mui/material/Box';
import type { MotionProps } from 'framer-motion';

import Box from '@mui/material/Box';
import { m } from 'framer-motion';
import React from 'react';

import { varContainer } from './variants/container';

// ----------------------------------------------------------------------

type IProps = MotionProps & BoxProps;

export interface Props extends IProps {
  animate?: boolean;
  action?: boolean;
}

function MotionContainer({
  action = false,
  animate,
  children,
  ...other
}: Props) {
  if (action) {
    return (
      <Box
        animate={animate ? 'animate' : 'exit'}
        variants={varContainer()}
        component={m.div}
        initial={false}
        {...other}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      variants={varContainer()}
      component={m.div}
      initial="initial"
      animate="animate"
      exit="exit"
      {...other}
    >
      {children}
    </Box>
  );
}

export default React.memo(MotionContainer);
